import { isEmpty } from 'lodash';

import { LeashContent } from 'leash/utilities/localStorage/leashContentStorage';
import { TravelMethodId } from 'leash/utilities/const';
import {
  TravelEligibility,
  TravelMethod,
  TravelMethodIdType,
  TravelTypeIdType,
} from 'leash/types';
import { apiPackage } from 'utilities/http/api/leash/apiPackage';
import { Address } from 'types';

export const fetchTravelEligibility = async (
  puppyId: number,
  address: Address,
): Promise<TravelEligibility[]> => {
  const resp = await apiPackage.getTravelEligibility(puppyId, address);

  if (!resp.isOk) {
    throw Error('Error fetching travel eligibility');
  }

  return resp.json.eligibility;
};

export const buildEligibilityTravelMethods = (
  travelTypeId: TravelTypeIdType,
  travelEligibility: TravelEligibility[],
): TravelMethod[] => {
  travelEligibility = travelEligibility.filter((t) =>
    LeashContent?.systemSettings?.isLocalDeliveryAndHubPassThruActive
      ? t
      : t.travelMethod.id !== TravelMethodId.LocalDelivery &&
        t.travelMethod.id !== TravelMethodId.HubPassThru,
  );

  travelEligibility = travelEligibility.filter(
    (travel) => travel.travelType.id === travelTypeId,
  );

  return travelEligibility.map((eligibility) => ({
    ...eligibility.travelMethod,
    isEligible: eligibility.isEligible,
  }));
};

export const getSelectedEligibility = (
  travelTypeId: TravelTypeIdType,
  travelMethodId: TravelMethodIdType,
  travelEligibility: TravelEligibility[],
): undefined | TravelEligibility => {
  if (isEmpty(travelEligibility)) return undefined;

  return travelEligibility.find((travelEligible) => {
    return (
      travelEligible.travelType.id === travelTypeId &&
      travelEligible.travelMethod.id === travelMethodId
    );
  });
};
